import { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { AuthContext } from '../../../../context/authContext';
import alumnosApiService from '../../../../services/http/alumnosApiService';
import otrosApiService from '../../../../services/http/otrosApiService';
import matriculacionApiService from '../../../../services/http/matriculacionApiService';
import presupuestosApiService from '../../../../services/http/presupuestosApiService';
import useUsuarioValidation from './useUsuarioValidation';
import { getItem, setItem, STORAGE_KEYS } from '../../../../services/storage';

const useUsuarioForm = (empresaId, mode = 'alumno') => {
  const navigate = useNavigate();
  const { userOU } = useContext(AuthContext);
  const { idCedesca, idCntec, centro } = userOU;

  // Estados de error
  const [errorPart1, setErrorPart1] = useState(true);
  const [errorPart2, setErrorPart2] = useState(true);
  const [errorPart3, setErrorPart3] = useState(true);
  const [errorPart4, setErrorPart4] = useState(true);

  const [newId, setNewId] = useState();
  // Otros estados
  const [text, setText] = useState('');
  const [stay, setStay] = useState(true);
  const [modal, setModal] = useState(false);
  const [age, setAge] = useState(0);
  const [yearsApi, setYearsApi] = useState('');
  const [academicFormation, setAcademicFormation] = useState('');
  const [formationCenter, setFormationCenter] = useState([]);
  const [country, setCountry] = useState('');
  const [province, setProvince] = useState('');
  const [poblation, setPoblation] = useState('');
  const [document, setDocument] = useState('');
  const [cp, setCP] = useState('');
  const [poblationFiltered, setPoblationFiltered] = useState('');
  const [poblationBirthFiltered, setPoblationBirthFiltered] = useState('');
  const [cpFiltered, setCPFiltered] = useState('');
  const [studiesList, setStudiesList] = useState([]);
  const [studiesList2, setStudiesList2] = useState([]);
  const [fidelitationlist, setFidelitationList] = useState([]);
  const [sitLaboralList, setSitLaboralList] = useState([]);
  const [lastStudiesList, setLastStudiesList] = useState('');
  const [parentescoList, setParentescoList] = useState([]);

  // Refs para los campos de entrada
  const rowRef1 = useRef(null);
  const rowRef2 = useRef(null);
  const rowRef3 = useRef(null);
  const rowRef4 = useRef(null);

  // Hook de validación
  const { validate } = useUsuarioValidation(
    setErrorPart1,
    setErrorPart2,
    setErrorPart3,
    setErrorPart4,
    age,
    formationCenter,
    rowRef1,
    rowRef2,
    rowRef3,
    rowRef4,
  );

  // Función para obtener el email del usuario desde storage
  const getUserEmail = () => {
    const user = getItem(STORAGE_KEYS.USER);
    return user?.profileObj?.email || '';
  };

  // Variable de Formik
  const formik = useFormik({
    initialValues: {
      nombre: '',
      apellidos: '',
      tipoDocumento: '-1',
      documento: '',
      fechaNacimiento: '',
      pais: 'España',
      provincia: '',
      municipio: '',
      cp: '',
      domicilio: '',
      paisNacimiento: 'España',
      provinciaNacimiento: '',
      municipioNacimiento: '',
      nacionalidad: '',
      nss: '',
      centro: '-1',
      sexo: '0',
      emailPers: '',
      telefono: '',
      movil: '',
      idioma: 'Español',
      idalu: '',
      sede: '',
      nee: '',
      tsi: '',
      situacionLaboral: '',
      formacionAcademica: '-1',
      antiguoCentro: '',
      antiguosEstudios: '',
      notaMedia: 0,
      siguientesEstudios: '',
      formaAcceso: '-1',
      emailCorp: '',
      fechaUltimoCurso: '',
      fechaTitulo: '',
      ultimaMatricula: '',
      nombreTutor: '',
      apellido1Tutor: '',
      apellido2Tutor: '',
      telefonoTutor: '',
      movilTutor: '',
      emailTutor: '',
      tipoDocumentoTutor: '-1',
      documentoTutor: '',
      parentescoTutor: '0',
      nombreTutor2: '',
      apellido1Tutor2: '',
      apellido2Tutor2: '',
      telefonoTutor2: '',
      movilTutor2: '',
      emailTutor2: '',
      tipoDocumentoTutor2: '-1',
      documentoTutor2: '',
      parentescoTutor2: '0',
      conocer: '0',
      dndconocer: '',
      userEmail: getUserEmail(),
    },
    validateOnChange: false,
    validate,
    onSubmit: async (values) => {
      try {
        if (mode === 'lead') {
          const dataLead = await presupuestosApiService.crearLead(values, {
            headquarter: empresaId,
          });

          setModal(true);
          if (dataLead.exists) {
            setText('Este lead ya existe, revise el documento o email.');
            setStay(true);
            const v = {
              id: dataLead.Id_lead,
              nombre: values.nombre,
              apellidos: values.apellidos,
              empresaId,
            };
            setItem(STORAGE_KEYS.STUDENT, v);
            setNewId(dataLead.Id_lead);
            setStay(false);
          } else {
            const v = {
              id: dataLead.Id_lead,
              nombre: values.nombre,
              apellidos: values.apellidos,
              empresaId,
            };
            setItem(STORAGE_KEYS.STUDENT, v);
            setNewId(dataLead.Id_lead);
            setText('Lead creado.');
            setStay(false);
            navigate('/presupuestos/nuevo');
          }
          return;
        }

        const dataCreacionUsuario = await alumnosApiService.crearUsuario(values, {
          empresaId,
          headquarter: empresaId,
        });

        setModal(true);
        if (dataCreacionUsuario.exists !== undefined && dataCreacionUsuario.exists === true) {
          setText('Este alumno ya existe, revise el documento.');
          setStay(true);
        } else {
          const ccodcli = dataCreacionUsuario.response.split(':');

          const v = {
            id: ccodcli[1],
            nombre: values.nombre,
            apellidos: values.apellidos,
            empresaId,
          };

          setItem(STORAGE_KEYS.STUDENT, v);
          setNewId(ccodcli[1]);
          setText('Alumno creado.');
          setStay(false);

          await otrosApiService.createDriveFolder({
            db: empresaId,
            nombre: values.nombre,
            apellidos: values.apellidos,
            dni: values.documento,
            idCentro: values.centro,
          });

          let empresa = 'cedesca';
          if (empresaId === 'CNTEC' || empresaId === '0' || empresaId === 0) {
            empresa = 'cntec';
          }
          navigate(`/alumnos/${empresa}/${ccodcli[1]}/detalles`);
        }
      } catch (error) {
        setModal(true);
        setText(
          mode === 'lead'
            ? 'Ha ocurrido un problema al crear el lead.'
            : 'Ha ocurrido un problema al crear el usuario.',
        );
        setStay(true);
      }
    },
  });

  // Peticiones API
  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const dataAEscolares = await alumnosApiService.cargarAEscolares({
          empresaId,
          headquarter: empresaId,
        });
        const arrayFiltrado = dataAEscolares;
        const nuevoObjeto = { Id: '-1', Valor: '', Valor2: '' };
        arrayFiltrado.unshift(nuevoObjeto);
        setYearsApi(arrayFiltrado);
      } catch (error) {
        setYearsApi('');
      }

      try {
        const dataEstudios = await alumnosApiService.cargarEstudios({
          empresaId,
          procedence: '1',
        });
        setStudiesList([
          { Id_Estudio: 0, Estudio: '', Estudio_cast: '', Codigo_Estudios: 0 },
          ...dataEstudios,
        ]);
      } catch (error) {
        setStudiesList([]);
      }

      try {
        const dataEstudios2 = await alumnosApiService.cargarEstudios({
          empresaId,
          procedence: '0',
        });
        setStudiesList2([
          { Id_Estudio: 0, Estudio: '', Estudio_cast: '', Codigo_Estudios: 0 },
          ...dataEstudios2,
        ]);
      } catch (error) {
        setStudiesList2([]);
      }

      try {
        const dataFidelizacion = await matriculacionApiService.cargarFidelizacion({
          empresaId,
          procedence: '0',
        });
        setFidelitationList(dataFidelizacion);
      } catch (error) {
        setFidelitationList([]);
      }

      try {
        const dataUltimosEstudios = await alumnosApiService.cargarUltimosEstudios({
          empresaId,
        });
        const arrayFiltrado = dataUltimosEstudios;
        const nuevoObjeto = { Id: '-1', name: '' };
        arrayFiltrado.unshift(nuevoObjeto);
        setLastStudiesList(dataUltimosEstudios);
      } catch (error) {
        setLastStudiesList('');
      }

      try {
        const dataCentros = await alumnosApiService.cargarCentrosFormacion({
          empresaId,
        });
        const sedes = dataCentros.filter(
          (c) => c.Poblacion && String(c.Poblacion).trim() !== '',
        );
        const nuevoObjeto = { Id: '-1', Poblacion: '' };
        setFormationCenter([nuevoObjeto, ...sedes]);
      } catch (error) {
        setFormationCenter([]);
      }

      try {
        const dataFormaciones = await alumnosApiService.cargarFormacionesAcademicas({
          empresaId,
        });
        const arrayFiltrado = dataFormaciones;
        const nuevoObjeto = { Id: '-1', Nombre: '' };
        arrayFiltrado.unshift(nuevoObjeto);
        setAcademicFormation(arrayFiltrado);
      } catch (error) {
        setAcademicFormation('');
      }

      try {
        const dataPaises = await alumnosApiService.cargarPaises({ empresaId: '1' });
        setCountry(dataPaises);
      } catch (error) {
        setCountry('');
      }

      try {
        const dataProvincia = await alumnosApiService.cargarProvincia({ empresaId: '1' });
        setProvince(dataProvincia);
      } catch (error) {
        setProvince('');
      }

      try {
        const dataPoblaciones = await alumnosApiService.cargarPoblaciones({
          empresaId,
        });
        const arrayFiltrado = dataPoblaciones.filter((objeto) => objeto.provincia === '');
        setPoblationFiltered(arrayFiltrado);
        setPoblation(dataPoblaciones);
        setPoblationBirthFiltered(arrayFiltrado);
      } catch (error) {
        setPoblationFiltered('');
        setPoblation('');
        setPoblationBirthFiltered('');
      }

      try {
        const dataCps = await alumnosApiService.cargarCp({ empresaId });
        const arrayFiltrado = dataCps.filter((objeto) => objeto.nom_municipi === '');
        setCPFiltered(arrayFiltrado);
        setCP(dataCps);
      } catch (error) {
        setCPFiltered('');
        setCP('');
      }

      try {
        const dataDocumentos = await alumnosApiService.cargarDocumentos({
          empresaId,
        });
        const arrayFiltrado = dataDocumentos;
        setDocument(arrayFiltrado);
      } catch (error) {
        setDocument('');
      }

      try {
        const dataParentescos = await alumnosApiService.cargarParentescos({
          headquarter: empresaId,
        });
        const arrayFiltrado = dataParentescos;
        setParentescoList(arrayFiltrado);
      } catch (error) {
        setParentescoList([]);
      }

      try {
        const dataSituacionLaboral = await alumnosApiService.cargarSituacionLaboral({
          empresaId,
        });
        setSitLaboralList(dataSituacionLaboral);
      } catch (error) {
        setSitLaboralList([]);
      }
    };

    fetchOptions();

    /* eslint-disable no-restricted-globals */
    window.scrollTo(0, 0);
    history.scrollRestoration = 'manual';
    /* eslint-enable no-restricted-globals */
  }, [empresaId]);

  // Efecto para setear centro por defecto
  useEffect(() => {
    // Si el rol es de delegación, asignamos valor por defecto
    if (formationCenter.length > 0 && idCedesca > 0 && idCntec > 0) {
      const centroEncontrado = formationCenter.find((c) => c.Nombre === centro);
      if (centroEncontrado?.Id) {
        formik.setValues((prev) => ({
          ...prev,
          centro: centroEncontrado.Id,
          sede: centroEncontrado.Poblacion || '',
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formationCenter, idCedesca, idCntec, centro]);

  // Efecto para hacer scroll al primer campo con error
  useEffect(() => {
    if (errorPart1 || errorPart2 || errorPart3 || errorPart4) {
      // Buscar el primer input con error visible en el DOM
      setTimeout(() => {
        const firstError = window.document.querySelector('.border-danger');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus?.();
        } else if (errorPart1 && rowRef1.current) {
          rowRef1.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (errorPart2 && rowRef2.current) {
          rowRef2.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (errorPart3 && rowRef3.current) {
          rowRef3.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (errorPart4 && rowRef4.current) {
          rowRef4.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 50);
    }
  }, [errorPart1, errorPart2, errorPart3, errorPart4]);

  const handleFechaTitulos = (value) => {
    // Seteamos el valor a formik
    formik.setValues((prev) => ({ ...prev, fechaTitulo: value }));
  };

  const handleFechaNacimiento = (value) => {
    // Almacenamos la fecha en formik
    formik.setValues((prev) => ({ ...prev, fechaNacimiento: value }));

    // Convierte la cadena de fecha de nacimiento a un objeto Date
    const fechaNac = new Date(value);

    // Obtiene la fecha actual
    const fechaActual = new Date();

    // Calcula la diferencia en milisegundos entre la fecha actual y la fecha de nacimiento
    const diferencia = fechaActual - fechaNac;

    // Convierte la diferencia de milisegundos a años
    const edadEnAnios = Math.floor(diferencia / (1000 * 60 * 60 * 24 * 365.25));

    setAge(edadEnAnios);
  };

  const handleBirthProvinceChange = (event) => {
    formik.values.provinciaNacimiento = event.target.value;
    const arrayFiltrado = poblation.filter((objeto) => objeto.provincia === event.target.value);
    const nuevoObjeto = { nom_municipi: '', provincia: event.target.value };
    arrayFiltrado.unshift(nuevoObjeto);
    formik.values.municipioNacimiento = arrayFiltrado[0].nom_municipi;
    setPoblationBirthFiltered(arrayFiltrado);
  };

  const handleProvinceChange = (event) => {
    formik.values.provincia = event.target.value;
    const arrayFiltrado = poblation.filter((objeto) => objeto.provincia === event.target.value);
    const nuevoObjeto = { nom_municipi: '', provincia: event.target.value };
    arrayFiltrado.unshift(nuevoObjeto);
    formik.values.municipio = arrayFiltrado[0].nom_municipi;
    setPoblationFiltered(arrayFiltrado);
  };

  const handlePoblationChange = (event) => {
    formik.values.municipio = event.target.value;
    const arrayFiltrado = cp.filter((objeto) => objeto.nom_municipi === formik.values.municipio);
    setCPFiltered(arrayFiltrado);
    formik.values.cp = arrayFiltrado[0]?.cp || '';
  };

  return {
    formik,
    age,
    modal,
    text,
    stay,
    newId,
    empresaId,
    idCedesca,
    idCntec,
    centro,
    yearsApi,
    academicFormation,
    formationCenter,
    country,
    province,
    poblation,
    document,
    cp,
    poblationFiltered,
    poblationBirthFiltered,
    cpFiltered,
    studiesList,
    studiesList2,
    fidelitationlist,
    sitLaboralList,
    lastStudiesList,
    parentescoList,
    rowRef1,
    rowRef2,
    rowRef3,
    rowRef4,
    setModal,
    handleFechaTitulos,
    handleFechaNacimiento,
    handleBirthProvinceChange,
    handleProvinceChange,
    handlePoblationChange,
  };
};

export default useUsuarioForm;
